import COM from './Grid'

export default COM
